<template>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <v-row
      align="center"
      justify="center"
      class="fill-height ma-0"
    >
      <v-col
        cols="12"
        class="text-center"
      >
        <span class="subtitle-1">Sua transação foi aprovada!</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "NoTypeMainInfo",
  }
</script>

<style scoped>

</style>
